import { SEND_FEEDBACK, SEND_FEEDBACK_SUCCESS, SEND_FEEDBACK_FAILURE } from '../actions/actionTypes'
const sendFeedbackReducer = (state = { data: null, isLoading: false, error: null }, actionPayload = { type: null, payload: null }) => {
  const { type, payload } = actionPayload
  switch (type) {
    case SEND_FEEDBACK:
      return {
        ...state,
        status: null,
        isLoading: true
      }
    case SEND_FEEDBACK_SUCCESS:
      return {
        ...state,
        data: payload,
        status: true,
        error: null,
        isLoading: false
      }
    case SEND_FEEDBACK_FAILURE:
      return {
        ...state,
        status: false,
        error: payload,
        isLoading: false
      }
    default:
      return state
  }
}

export default sendFeedbackReducer
